import { render, staticRenderFns } from "./LocalStorageInformation.vue?vue&type=template&id=512885f8&"
import script from "./LocalStorageInformation.vue?vue&type=script&lang=js&"
export * from "./LocalStorageInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports